type IStatus =
  | '확정'
  | '상품 제작 중'
  | '파일 생성 중'
  | '최종 성공'
  | '전송중'
  | '전송 실패'
  | '최종 전송 완료';

type ICode =
  | 'CONFIRM'
  | 'PROGRESSING'
  | 'PDF_PROGRESSING'
  | 'SUCCESS'
  | 'SEND_PENDING'
  | 'SEND_FAIL'
  | 'SEND_SUCCESS';
/**
 * @author taulmax
 * @date 2024.12.06
 * @description AG GRID TABLE에 들어갈 현황 컴포넌트
 */
const Status = ({ status, code }: { status: IStatus; code: ICode }) => {
  return <span className={`grid_status ${code}`}>{status}</span>;
};

export default Status;
